import { paymentOptions } from "../utils/constants";

const createHelpLink = (route, links) => ({
  [route]: links.map(({ title, link, removable = false }) => ({
    title: `supportLink.${title}`,
    link: link,
    ...(removable && { removable: true }),
  })),
});

const HelpLinks = {
  ...createHelpLink("/login", [
    { title: "getInvite", link: "/onboarding-guide#invitation" },
    { title: "logIn", link: "/onboarding-guide#login" },
    { title: "signUp", link: "/onboarding-guide#signup" },
  ]),
  ...createHelpLink("/invite", [
    { title: "getInvite", link: "/onboarding-guide#invitation" },
    { title: "logIn", link: "/onboarding-guide#login" },
    { title: "signUp", link: "/onboarding-guide#signup" },
  ]),
  ...createHelpLink("/home", [
    { title: "aboutHome", link: "/onboarding-guide#home-page" },
    { title: "transfer", link: "/onboarding-guide#initiating-transfer" },
  ]),
  ...createHelpLink("/withdraw/0", [
    { title: "transferHowTo", link: "/videos" },
  ]),
  ...createHelpLink("/withdraw/1", [
    { title: "paymentMethod", link: "/onboarding-guide#choose-payment-method" },
    { title: "transferHowTo", link: "/videos" },
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
      removable: true,
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
      removable: true,
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
      removable: true,
    },
  ]),
  ...createHelpLink(`/withdraw/2/${paymentOptions.crypto}`, [
    { title: "paymentMethod", link: "/onboarding-guide#choose-payment-method" },
    { title: "transferHowTo", link: "/videos" },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.crypto}`, [
    {
      title: "provideWallet",
      link: "/onboarding-guide#provide-wallet-and-review-transfer-details",
    },
    { title: "transferHowTo", link: "/videos" },
  ]),
  ...createHelpLink(`/withdraw/2/${paymentOptions.masspay}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.masspay}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
  ]),
  ...createHelpLink(`/withdraw/4/${paymentOptions.masspay}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
  ]),
  ...createHelpLink(`/withdraw/5/${paymentOptions.masspay}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),
  ...createHelpLink(`/withdraw/6/${paymentOptions.masspay}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),

  //pockyt
  ...createHelpLink(`/withdraw/2/${paymentOptions.pockyt}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.pockyt}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.pockyt}/summary`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },

  ]),
  ...createHelpLink(`/withdraw/4/${paymentOptions.pockyt}`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),
  ...createHelpLink(`/withdraw/4/${paymentOptions.pockyt}/summary`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),
  
  // xbd

  ...createHelpLink(`/withdraw/2/${paymentOptions.xbd}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.xbd}`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),
  ...createHelpLink(`/withdraw/3/${paymentOptions.xbd}/summary`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),
  ...createHelpLink(`/withdraw/4/${paymentOptions.xbd}`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),
  ...createHelpLink(`/withdraw/4/${paymentOptions.xbd}/summary`, [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
    {
      title: "cancelTransfer",
      link: "/general-faqs#can-i-cancel-the-transfer-after-confirming-it",
    },
  ]),

  // bank
  ...createHelpLink(`/bank`, [
    {
      title: "bankTransferHowTo",
      link: "/guide-onboarding-and-transfers#non-crypto-payment-method-process",
    },
    {
      title: "currencyOption",
      link: "/general-faqs#can-i-choose-a-different-currency-for-the-transfer",
    },
    {
      title: "bankTransferDetails",
      link: "/general-faqs#what-bank-details-do-i-need-to-provide-for-the-transfer",
    },
    {
      title: "detailsSafe",
      link: "/general-faqs#is-my-payment-information-secure-during-the-transfer-process",
    },
  ]),

  ...createHelpLink("/withdraw/status", [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
  ]),
  ...createHelpLink("/withdraw/details", [
    {
      title: "transferPeriod",
      link: "/general-faqs#how-long-does-it-take-for-the-money-to-reach-my-bank-account",
    },
  ]),
};

export default HelpLinks;
